import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { FormDataService } from '@app/_core/services/form-data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, map, Subject } from 'rxjs';

import { DisconnectCallComponent } from '../disconnect-call/disconnect-call.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { WindowsWrapperService } from '@app/_core/services/windows-wrapper.service';
@Component({
  selector: 'app-identify-user',
  templateUrl: './identify-user.component.html',
  styleUrl: './identify-user.component.scss',
})
export class IdentifyUserComponent implements OnInit {
  @Input()
  Heading: any;
  @Input()
  reason: any;
  @Input()
  notFound: any;
  showSearch: boolean;
  @Input() showAddUser: boolean;
  @Input()
  searchMemberObject: object;
  user: any;
  company: any;
  activityId: any;
  queueID: any;
  selectedUserID: any;
  addedUserID: any;
  sectionHeader: string;
  pageHeader: string;
  inboundNumber: string;
  modalRef?: BsModalRef;
  clientAbbreviation: string;
  externalUserID: any;
  hideUnknownNewbtn: boolean = false;
  constructor(
    private tmQueueService: TmQueueService,
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private WindowsWrapper: WindowsWrapperService,
    private appService: AppService,
    private cdref: ChangeDetectorRef,
      private dialerService: DialerService,
      private mainController: MainControllerComponent
  ) {
    this.dialerService.ivrUserID.subscribe((ivrUserID: number) => {
      this.selectedUserID=ivrUserID;
    });
    this.dialerService.phoneNo.subscribe((phoneNumber: string) => {
      this.inboundNumber = phoneNumber;
    });

      this.tmQueueService.Transfer_SUBMIT_CALL.subscribe(value => {
          if (value && !this.mainController.getSearchUserSelected()) {
              this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
          }
      });
  }

  async ngOnInit(): Promise<void> {
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.loadParameters();
    this.showSearch = true;
    this.pageHeader = "Confirm the user's identity";
    this.sectionHeader = 'USER INFORMATION';
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.searchForUser();
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });
    this.mainController.setSearchUserSelected(false);
    this.mainController.startVideoRecording();
  }

  loadParameters() {
    this.queueService
      .GetSearchParams()
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetQueues');
          if (isValid) {
            // console.log("this.dataToDisplay",data)
            this.hideUnknownNewbtn = data.Response.Data.HideUnknownNewbtn;
           // console.log('HideUnknownNewbtn:',this.hideUnknownNewbtn);
            
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  handleSelectedUser(event) {
    if (event != 'not-found') {
      if(event.length==1)
      {
        this.mainController.setSearchUserSelected(true);

        if(event && event[0].UserID == -1){
          this.CreateExternalRecord(event[0].CrmUserID, externalID =>{ 
            event[0].UserID = externalID;  // Process after CreateExternalRecord completes
            this.setCurrentCallee(event[0].UserID);
            this.appService.setActionItemId(this.queueID + '-' + event[0].UserID + '-' + event[0].CaseID);
            this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
          });
        }else{
          this.setCurrentCallee(event[0].UserID);
          this.appService.setActionItemId(this.queueID + '-' + event[0].UserID + '-' + event[0].CaseID);
          this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
        }
      }
    }
  }

  CreateExternalRecord(externalID: string, callback: (id: any) => void) {
    this.queueService.CreateExternalRecord(externalID).subscribe({
      next: res => {
        this.externalUserID = res.Response.Data;
        console.log('Received external user ID:', this.externalUserID);
        callback(this.externalUserID); // call the callback after getting the data
      },
      error: err => {
        console.error('Error creating external record:', err);
      },
    });
  }

  closeCaseCreation() {
    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide();
  }
  searchForUser() {
    this.searchMemberObject = {
      type: this.selectedUserID ? 'ID':'Phone #',
      value: this.selectedUserID ? this.selectedUserID:this.inboundNumber,
    };
  }

  setCurrentCallee(userID) {
    this.tmQueueService.setCurrentCallee(this.queueService.getCallID(), userID).subscribe(data => {
      //console.log('setCurrentCallee response', data);
    });
  }

  handleUnknownContact() {
      this.appService.setActionItemId(this.queueID + '-null-null');
      this.mainController.setSearchUserSelected(true);
      this.appService.setIsAddNewUser(true);
      this.mainController.setIsUnknownContact(true);
      this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
  }

  handleDisconnectCall() {
    this.DisconnectCall();
    const initialState = {};
    const config: ModalOptions = {
      backdrop: 'static',
      class: 'disconnect-call',
      initialState,
    };
    this.modalRef = this.modalService.show(DisconnectCallComponent, config);
    this.modalRef.content.onClose = new Subject<boolean>();
  }

  DisconnectCall() {
    this.tmQueueService
        .CancelCall(false, this.queueService.getCallID(), this.queueService.getGroupTransferInteractionID())
      .subscribe();
    }

    getRequestType() {
        return this.mainController.getRequestType();
    }
}
